const { fetchDomainConfiguration } = require('../utils/common/DomainConfiguration');

//fetching whitelabel configuration
let whiteLabelConfig = fetchDomainConfiguration();

const configUrl = {
    BASE_URL_SOCKET_IO_PATH: '/careontel-socket-server',
    // DISABLE_OWNER_ON_VIDEO_CALL: "visit/disable-owner-on-video-call",
    isDevelopment: false,
    isShowVideoConsultationOnly: false,
    isPatientSignUpOnly: true,
    isHideVideoConsultationOnly: true,
    timerLimitMessage: 'Your session time is ended',
    userTypePhysician: 'PHYSICIAN',
    isGoogleAddressLocator: false,
    API_KEY: '',
    ZIP_CODE_API_URL: 'https://api.zippopotam.us/',
    COUNTRY: 'IN',
    LOGIN_NEW: 'api/v4/user/authenticate',
    GRA_SINGOUT: 'api/v4/user/signOut',
    CHNAGE_PASSWORD: 'api/v4/user/change/password',
    FORGET_PASSWORD: '/api/v4/user/forget/password',
    GET_CLEVER_USER_INFORMATION: 'api/v4/user',
    ADD_USER_CONTACT_INFORMATION: 'api/v4/user-profile',
    GET_USER_INFORMATION: 'api/v4/user',
    VIDEO_CALL_END_VISIT_NEW: 'api/v4/visit',
    RECORD_START: 'api/physician/visit/record/start',
    RECORD_STOP: 'api/physician/visit/record/stop',
    ADDRESS_SEATCH: 'api/common/search/places',
    FILE_DOWNLOAD: 'api/user/download?',
    GET_VISIT_DETAILS: 'api/v4/visit',
    GET_VONAGE_SESSION: 'api/v4/visit/vonage-session',
    VISIT_STATUS: 'api/v4/bloomifai/visit/status',
    CLEVER_LEVEL3_LIST: 'api/v4/level-3-list-by-clever',
    ADD_INSTITUTION_RELATION: 'api/v4/user-institution-relation',
    HIDE_REMIND_ME_LATE: 'api/v4/user/profile-update',
    BYPASS_TOKEN: '/api/v4/token',
    SUPER_ADMIN: {
        ADMIN_NOTIFICATION: 'api/v4/notification',
        NOTIFICATION_COUNT: 'api/v4/notification/count',
        MARK_AS_READ: 'api/v4/notification/mark-all-as-read',
        VERIFY_USER: 'api/v4/user/verify/',
        USERDETAILS: 'api/v4/user/',
        REJECT_TUTOR: 'api/v4/user/reject',
        SYSTEM_FEATURE: 'api/v4/setting/system-feature',
    },

    INS_SUPER_ADMIN: {
        DASHBOARD: 'api/v4/admin-summary',
        ACTIVE_INSTITUTION: 'api/v4/institution/branch/status',
        TUTORLIST: 'api/v4/voim/tutors',
        TOP_LEVEL: 'api/v4/hierarchy',
        STUDENTS_LEVEL: 'api/v4/users/institution/',
        TIME_ZONES: '/api/v4/timezones',
        FINANCIAL_REPORT: 'api/v4/report/admin/finance',
        DASHOARD_LEVEL_REPORTS: 'api/v4/educator/payout',
        PASSWORD_CONFIRM: 'api/v4/user/password',
        PAYOUT_STATUS: 'api/v4/utility/tab',
    },

    LEVEL_ONE_ADMIN: {
        DASHBOARD: 'api/v4/hierarchy-summary',
        ACTIVATELEVEL: 'api/v4/hierarchy/status',
        GET_LEVEL: 'api/v4/hierarchy',
        ADD_SECOND_LEVEL: 'api/v4/hierarchy',
    },

    BRANCH_ADMIN: {
        DASHBOARD: 'api/v4/branch-admin-summary',
        GET_USER: 'api/v4/user',
        GETVISITSBYSTUDENTID: 'api/v4/visit/user',
        CREATEUSER: 'api/v4/user',
        UPDATEUSER: 'api/v4/user/update',
        GET_SUB_CATEGORY: 'api/v4/expertises',
        GET_EXPERTISE_LEVEL: 'api/v4/tutor-expertise-level',
        GET_SUBJECT: 'api/v4/expertise/category',
        ADD_SUBJECT: 'api/v4/voim/expertise/category',
        ADD_SUB_CATEGORY: 'api/v4/voim/expertise',
        GET_TUTOR: 'api/v4/tutor',
        GET_SESSSION_LIST: 'api/v4/visit',
        GET_BRANCH_ADMIN_SESSSION_LIST: 'api/v4/sessions',
        GET_PHYSICIAN_AVAILABILITY: 'api/v4/availability/tutor/',
        APPOINTMENT_BOOKING: 'api/v4/visit/book',
        CANCELATION_REQUEST_LIST: 'api/v4/visit/cancel/request',
        CANCEL_SESSION: 'api/v4/visit',
        REJECT_SESSION_REQUEST: 'api/v4/visit/reject/request',
        GET_SUB_CATEGORY_STATUS: 'api/v4/expertise',
        GET_SUBJECT_LIST: 'api/v4/expertise-categories',
        GET_SUB_CATEGORY_LIST: 'api/v4/expertises/category',
        GET_TUTOR_LIST: 'api/v4/expertises',
        GET_EDUCATOR_AVAILABILITY: 'api/v4/availability/tutor/',
        GET_AVAILABE_STUDENTS: 'api/v4/available-students',
        GET_AVAILABE_LEVEL3_STUDENTS: 'api/v4/visit/student/level-wise',
        CREATE_SESSION: 'api/v4/visit/book',
        BULK_BATCH_UPLOAD_EDUCATOR: '/api/v4/user/bulk-upload',
        BULK_BATCH_UPLOAD_STATUS: 'api/v4/bulk-upload-file/error/details',
        GET_FLAGSESSION_STATUS: 'api/v4/visit',
        DASHOARD_EDUCATORS_REPORTS: 'api/v4/educator/payout/branch-admin',
        GET_SUBCATEGORY_REPORT: 'api/v4/visit/session-history/expertiseCount',
        GET_EDUCATOR_REPORT: 'api/v4/visit/session-history/educatorCount',
        GET_STUDENT_HISTORY: 'api/v4/visit/student',
        UPDATE_STUDENT_PASSWORD: 'api/v4/user/update/password',
        GET_BROADCAST_LIST: 'api/v4/sessions',
        GET_LEVELTHREE_INSTITUTION: 'api/v4/institution/level2',
        GET_STUDENT_LIST: 'api/v4/student/level3',
        GET_LEVEL_EDUCATOR: 'api/v4/institution/educator/',
        BULK_BATCH_UPLOAD_STUDENTS: '/api/v4/user/inactive-student/bulk-upload',
        BULK_BATCH_UPLOAD_STATUS_STUDENTS: 'api/v4/bulk-upload-file/error/details',
        GET_BATCH_UPLOAD_HISTORY: 'api/v4/bulk-upload/file',
    },

    PHYSICIAN: {
        GET_PARTICULAR_VISIT: 'api/v4/visit',
        CALL_STATUS: 'api/v4/visit/',
        GET_PATIENT_CHAT_LIST: 'api/v4/visit/',
        PATIENT_VISIT_LIST: 'api/v4/visit',
        FULL_PATIENT_LIST: 'api/v4/visit',
        DROPDOWN_SESSION: 'api/v4/visit/student',
        GET_SUMMARY: 'api/v4/tutor/utility/soap-notes',
        UPDATE_SOAP_NOTES: 'api/v4/tutor/utility/soap-notes',
        UPDATE_SUMMARY_SOAP_NOTES: 'api/v4/tutor/utility/summary-soap-notes',
        TUTOR_HANDOUT: '/api/v4/tutor/utility/handout',
        CUSTOMIZE_PATIENT_VIEW: 'api/v4/tutor/utility/setting',
        STUDENT_INFORMATION: '/api/v4/students',
        GET_EDUCATOR_AVAILABILITY: 'api/v4/educator/availability/',
        UPDATE_SUMMARY_NOTES: 'api/v4/tutor/utility/soap-notes/summary',
    },

    IM_PHYSICIAN: {
        VISIT_CHAT_LIST: 'api/v4/visit',
    },

    IM_PATIENT: {
        VISIT_CHAT_LIST: 'api/v4/visit',
    },

    IM_EDUCATOR: {
        GET_TUTORAPPOINTMENT_SESSION_LIST: 'api/v4/sessions',
        CANCELATION_REQUEST_APPONTMENT_SESSION_LIST: '/api/v4/visit',
        RESCHEDULE_SESSION: 'api/v4/visit/reschedule',
        GET_NUMBER_OF_STUDENTS_LIST: 'api/v4/session',
        AVAILABLE_STUDENT: '/api/v4/available-students',
        REMOVE_IMAGES: '/api/v4/visit/attachment',
        GET_EDUCATOR_DETAILS: 'api/v4/user-profile',
        UPDATE_EDUCATOR_PROFILE: 'api/v4/user',
        AVAILABILITY: 'api/v4/availability',
        CUSTOM_AVAILABILITY: 'api/v4/educator/custom-availability',
        GET_VISIT_INFORMATON: 'api/v4/visit',
        GET_STUDENT_INFO_DATE: 'api/v4/visit/student',
        GET_FLAGSESSION: 'api/v4/visit/flagged-categories',
        PUT_FLAGSESSION: 'api/v4/visit/flagged',
        GET_FINANCIAL_REPORT_SESSION_WISE: 'api/v4/visit/payout',
        GET_FINANCIAL_REPORT_PAYOUT_HISTORY: 'api/v4/tutor/payout/history',
        GET_FINANCIAL_REPORT_STRIPE_DETAILS: 'api/v4/tutor/utility/payouts',
        SETUP_STRIPE_CONNECTION: 'api/v4/tutor/utility/account',
        EDUCATOR_FUND_TRANSFER: 'api/v4/user-fund/transfer/confirm',
        GET_STUDENT_HISTORY: '/api/v4/visit/student',
        START_BROADCAST_SESSION: 'api/v4/visit',
        GET_AVAILABE_BROADCAST_STUDENTS: 'api/v4/visit/student/level-wise',
        LAYOUT_CHANGE: 'api/v4/visit/layout-change',
        REMOVE_CLASSROOM_STUDENT: 'api/v4/visit/student-user',
        EDUCATOR_MUTE_MESSAGE_SEND: 'api/v4/utility/educator/mute',
        GET_EDUCATOR_FOR_REFERRAL: '/api/v4/referral-educator',
        SUBMIT_SESSION_REFERRAL: '/api/v4/session-referral',
        SUBMIT_SUBJECT_REFERRAL: '/api/v4/subject-referral',
        GET_REFERRAL_STUDENT_LIST: '/api/v4/referral-student',
        GET_CREATED_REFERRAL_LIST: '/api/v4/referral',
        GET_COMPLETED_REFERRAL_LIST: '/api/v4/completed-referral',
        GET_SUBJECT_REFERRAL_SUMMARY: 'api/v4/subject-referral',
        GET_PREVIOUS_STUDENT_LIST: '/api/v4/chat-message/previous-user',
        GET_ALL_STUDENT_LIST: '/api/v4/chat-student',
        GET_STUDENT_CHAT_LIST: '/api/v4/chat-message/history',
        GET_EDUCATOR_FILE_UPLOAD: '/api/v4/chat-message/file',
        GET_EDUCATOR_FILE_DOWNLOAD: '/api/v4/chat/file-url',
        GET_UNREAD_PREVIOUS_USER_LIST: 'api/v4/chat-message/previous-user/unread/',
        GET_ALL_SESSION_LIST: 'api/v4/sessions',
        GET_ALL_CHAT_HISTORY: 'api/v4/chat-message/history/all',
        EDUCATOR_WHITEBOARD_OPEN: 'api/v4/utility/whiteboard-open',
        JOIN_IN_PERSON_SESSION: 'api/v4/visit',
        ANONYMOUS_USER_DETAILS:"/api/v4/anonymous-user/profile",
    },

    IM_STUDENT: {
        GET_STUDENTS_SESSION_LIST: 'api/v4/sessions',
        GET_EDUCATOR_LIST: '/api/v4/expertises',
        GET_EDUCATOR_AVAILABILITY: '/api/v4/availability/tutor',
        POST_ONDEMAND: '/api/v4/visit/book',
        GET_STUDENT_DETAILS: '/api/v4/user-profile',
        UPDATE_STUDENT_PROFILE: 'api/v4/user',
        GET_VISIT_INFORMATON: 'api/v4/visit/',
        ATTACHMENT_SAVE: '/api/v4/visit/attachment',
        ENTER_ROOM: '/api/v4/visit',
        EDUCATOR_LIST_FOR_CHAT: '/api/v4/chat-educator',
        EDUCATOR_PREVIOUS_LIST_FOR: '/api/v4/chat-message/previous-user',
        GET_EDUCATOR_CHAT_LIST: '/api/v4/chat-message/history',
        GET_STUDENT_FILE_UPLOAD: '/api/v4/chat-message/file',
        GET_STUDENT_FILE_DOWNLOAD: '/api/v4/chat/file-url',
        GET_STUDENTS_EDUCATOR: 'api/v4/educator-ondemand',
        GET_STUDENTS_EDUCATOR_SUBJECT: 'api/v4/subject/educator',
        GET_STUDENTS_EDUCATOR_SUBCATEGORY: 'api/v4/subcategory/educator',
        GET_UNREAD_PREVIOUS_USER_LIST: 'api/v4/chat-message/previous-user/unread/',
        GET_ALL_SESSION_LIST: 'api/v4/sessions',
        GET_ALL_CHAT_HISTORY: 'api/v4/chat-message/history/all',
    },
    COMMON_ENDPOINT: {
        ACTIVATEUSER: 'api/v4/user/status',
        USERLIST: 'api/v4/users',
        GET_SUB_CATEGORY: '/api/v4/expertises/category',
        GET_SUBJECT: '/api/v4/expertise-categories',
        GET_EDUCATOR_AVAILABILITY_DAYS: 'api/v4/availability/days',
        DASHBOARD_DETAILS: '/api/v4/dashboard/details',
        DASHBOARD_APPOINTMENT_DETAILS: '/api/v4/current/appointments',
        CREATE_CLASSROOM_SESSION: '/api/v4/classroom-session',
        VISIT_THIRD_PARTY: '/api/v4/visit/third-party',
        FETCH_STUDENT_ATTENDANCE: '/api/v4/session',
        STUDENT_ADD_NOTES: 'api/v4/visit/student-notes',
        UNREAD_COUNTS: 'api/v4/chat/un-read',
    },
};

configUrl['hostname'] = window.location.hostname;
configUrl['basePath'] =
    `${window.location.protocol}//${configUrl.hostname}:${window.location.port}`;

configUrl['INS_BASE_REST_URL'] = whiteLabelConfig.ins_rest_url;
configUrl['INS_BASE_SOCKET_URL'] = whiteLabelConfig.ins_socker_url;
configUrl['BUFFER_TIMING'] = whiteLabelConfig.bufferTiming;
configUrl['FINAL_BUFFER_TIMING'] = whiteLabelConfig.finalBufferTiming;
configUrl['CLEVER_LOGIN_URL'] = whiteLabelConfig.cleverLoginUrl;
configUrl['BASE_CONFIG_URL'] = whiteLabelConfig.url;
configUrl['isWhiteLabled'] = whiteLabelConfig.whitelabeled;
configUrl['appname'] = whiteLabelConfig.appname;
configUrl['apptitle'] = whiteLabelConfig.title;
configUrl['paginationCount'] = whiteLabelConfig.paginationCount;
module.exports = configUrl;
